
import { Crown } from "lucide-react";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

const PremiumHeader = () => {
  const { language } = useLanguage();
  
  return (
    <div className="flex flex-col items-center text-center mb-10 animate-fade-up">
      <div className="inline-flex items-center justify-center p-2 bg-amber-100 rounded-full mb-4">
        <Crown className="h-6 w-6 text-amber-600" />
      </div>
      <h1 className="text-3xl font-bold tracking-tight md:text-4xl">
        {t('premium.title', language)}
      </h1>
      <p className="mt-3 text-muted-foreground max-w-lg">
        {t('premium.subtitle', language)}
      </p>
    </div>
  );
};

export default PremiumHeader;
